import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faEye, faComments, faUser } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../utils/helpers';
import { Post, User } from '../types/post.types';

interface PostInfoProps {
    post: Post;
    user: User;
}

const PostInfo: React.FC<PostInfoProps> = ({ post, user }) => {
    return (
        <div className="post-info">
            <span>
                <FontAwesomeIcon icon={faCalendar}/> {formatDate(post.createdAt)}
            </span>
            <span>
                <FontAwesomeIcon icon={faEye}/> {post.viewCount || 0}
            </span>
            <span>
                <FontAwesomeIcon icon={faComments}/> {post.commentCount || 0}
            </span>
            <span>
                <FontAwesomeIcon icon={faUser}/> {user.name || 'Unknown Author'}
            </span>
        </div>
    );
};

export default PostInfo; 